const PLAN_TIERS = {
    FREE: 'free',
    GROWTH: 'growth',
    BUSINESS: 'business',
    ENTERPRISE: 'enterprise',
};

export default PLAN_TIERS;
